<template>
  <div class="p-6">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      Reporte de Observaciones
    </h2>

    <div class="mb-4">
      <label class="block text-gray-700 font-semibold">Tipo de Reporte:</label>
      <select v-model="tipoReporte" class="border rounded p-2 w-full">
        <option value="M">Auditoría Médica</option>
        <option value="D">Análisis Documental</option>
      </select>
    </div>

    <div v-if="cargando" class="text-center text-gray-600">
      Cargando datos...
    </div>
    <div v-if="error" class="text-red-600">{{ error }}</div>

    <div v-if="maestros.length">
      <table class="w-full border-collapse border border-gray-300">
        <thead>
          <tr class="bg-gray-200">
            <th class="border border-gray-300 px-4 py-2">Número</th>
            <th class="border border-gray-300 px-4 py-2">Nombre</th>
            <th class="border border-gray-300 px-4 py-2">Observación</th>
            <th class="border border-gray-300 px-4 py-2">Descripción</th>
            <th class="border border-gray-300 px-4 py-2">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="maestro in maestros" :key="maestro.idPlaObs">
            <td class="border border-gray-300 px-4 py-2">
              {{ maestro.planillaNumero }}
            </td>
            <td class="border border-gray-300 px-4 py-2">
              {{ maestro.planillaNombre }}
            </td>
            <td class="border border-gray-300 px-4 py-2">
              {{ maestro.observacionDescripcion }}
            </td>
            <td class="border border-gray-300 px-4 py-2">
              {{ maestro.descripcion }}
            </td>
            <td class="border border-gray-300 px-4 py-2 text-center">
              <button
                @click="toggleExpandir(maestro.idPlaObs)"
                class="px-2 py-1 text-sm text-white bg-blue-500 hover:bg-blue-600 rounded"
              >
                {{ expandido[maestro.idPlaObs] ? "Ocultar" : "Ver Detalles" }}
              </button>
            </td>
          </tr>

          <template
            v-for="maestro in maestros"
            :key="'detalles-' + maestro.idPlaObs"
          >
            <template v-if="expandido[maestro.idPlaObs]">
              <tr
                v-for="detalle in detallesFiltrados[maestro.idPlanilla]"
                :key="detalle.idPlaDetObs"
                class="bg-gray-100"
              >
                <td colspan="4" class="border border-gray-300 px-4 py-2">
                  <div class="pl-6">
                    <p class="font-semibold">
                      Detalle: {{ detalle.planillaDetDescripcion }}
                    </p>
                    <p class="text-sm text-gray-600">
                      Observación: {{ detalle.observacionDescripcion }}
                    </p>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { ref, onMounted, computed, watch } from "vue";

import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const p_idtramite = ref(route.params.p_idtramite || "2"); // Toma el ID del trámite desde el router
    const tipoReporte = ref("M");
    const maestros = ref([]);
    const detalles = ref([]);
    const cargando = ref(true);
    const error = ref(null);
    const expandido = ref({});

    const cargarDatos = async () => {
      cargando.value = true;
      error.value = null;
      try {
        const { data: maestrosData } = await api.delete(`/vwplaobss/tramite-tipo/${p_idtramite.value}/${tipoReporte.value}`
        );
        maestros.value = Array.isArray(maestrosData) ? maestrosData : [];

        if (maestros.value.length > 0) {
          const idPlanilla = maestros.value[0].idPlanilla; // Tomar un idPlanilla válido
          const { data: detallesData } = await api.get(`/vwpladetobss/planilla-tipo/${idPlanilla}/${tipoReporte.value}`
          );
          detalles.value = Array.isArray(detallesData) ? detallesData : [];
        }

        maestros.value.forEach((m) => {
          expandido.value[m.idPlaObs] = false;
        });
      } catch (err) {
        error.value = "Error al cargar los datos.";
        console.error(err);
      } finally {
        cargando.value = false;
      }
    };

    watch(tipoReporte, cargarDatos);

    const detallesFiltrados = computed(() => {
      return maestros.value.reduce((acc, maestro) => {
        acc[maestro.idPlanilla] = detalles.value.filter(
          (detalle) => detalle.idPlanilla === maestro.idPlanilla
        );
        return acc;
      }, {});
    });

    const toggleExpandir = (idPlaObs) => {
      expandido.value[idPlaObs] = !expandido.value[idPlaObs];
    };

    onMounted(cargarDatos);

    return {
      maestros,
      detalles,
      cargando,
      error,
      expandido,
      detallesFiltrados,
      toggleExpandir,
      p_idtramite,
      tipoReporte,
    };
  },
};
</script>

<style scoped></style>
